import React, {useCallback, useEffect,useRef} from 'react';
import {SteppedEase, TweenMax} from "gsap";
import {useSelector} from "react-redux";

const Signature = (props) => {

    const signature = useRef();
    const accessible = useSelector(state => state.accessible);

    const runAnimation = useCallback(()=>{

        let animationEntryTime = 2000;

        setTimeout(()=>{

            if(props.status === 'active' && signature.current !== null){

                /** TODO get this responsive **/
                let sig = window.getComputedStyle(signature.current, "");
                let elHeight = parseFloat(sig.height.replace('px',''));

                let signatureDuration = 3;

                let height = elHeight * 61;
                TweenMax.to(signature.current,signatureDuration,{backgroundPosition: `0 -${height}px`,ease:SteppedEase.config(61)});

                /** hard set at end of animation for resizers **/
                setTimeout(()=>{
                    if(signature.current) signature.current.style.backgroundPosition= 'center bottom';
                },signatureDuration * 1000 + 200)

            }

        }, animationEntryTime);

    },[props.status]);

    useEffect(()=>{
        if(accessible.siteEntered) runAnimation()
    }, [runAnimation, accessible.siteEntered])

    return (
        <div ref={signature} {...props}/>
    )
};

export default Signature
